/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Formula_TitleInputs */

const tr_katalog_desi_page_formula_title = /** @type {(inputs: Katalog_Desi_Page_Formula_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl hesaplanır?`)
};

const en_katalog_desi_page_formula_title = /** @type {(inputs: Katalog_Desi_Page_Formula_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is it calculated?`)
};

const de_katalog_desi_page_formula_title = /** @type {(inputs: Katalog_Desi_Page_Formula_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird es berechnet?`)
};

const ru_katalog_desi_page_formula_title = /** @type {(inputs: Katalog_Desi_Page_Formula_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как рассчитать?`)
};

/**
* | output |
* | --- |
* | "How is it calculated?" |
*
* @param {Katalog_Desi_Page_Formula_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_formula_title = /** @type {((inputs?: Katalog_Desi_Page_Formula_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Formula_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_formula_title(inputs)
	if (locale === "de") return de_katalog_desi_page_formula_title(inputs)
	if (locale === "ru") return ru_katalog_desi_page_formula_title(inputs)
	return tr_katalog_desi_page_formula_title(inputs)
});